import React from 'react'
import styles from './ButtonIcon.module.sass'
import { cn } from '@utils/safeTs'
import Link from 'next/link'


interface Props {
  icon: React.ReactNode
  ariaLabel: string
  ariaExpanded?: boolean
  variant?: 'primary' | 'secondary' | 'ghost'
  colorVariant?: 'accent' | 'black'
  size?: 'xs' | 'sm' | 'md' | 'lg'
  type?: 'submit' | 'reset' | 'button'
  disabled?: boolean
  href?: string
  newPage?: boolean
  onClick?: (e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => void
  className?: string
}

const ButtonIcon = (props: Props) => {

  const { 
    icon,
    ariaLabel,
    ariaExpanded,
    variant = 'primary',
    colorVariant = 'accent', 
    size = 'md',
    type = 'button',
    disabled = false,
    href,
    newPage = false,
    onClick,
    className = '',
  } = props

  const classNames = cn(styles.root, styles[`root--${variant}`], styles[`root--${colorVariant}`], styles[`root--${size}`], className)

  return href ? (
    <Link href={href} onClick={onClick}>
      <a aria-label={ariaLabel}  target={newPage ? '_blank' : undefined} className={classNames}>
        {icon}
      </a>
    </Link>
  ) : (
    <button 
      type={type} 
      disabled={disabled}
      aria-label={ariaLabel}
      aria-expanded={ariaExpanded}
      onClick={onClick}
      className={classNames}
    >
      {icon}
    </button>
  )
}

export default ButtonIcon
